import React from 'react';
import LegalPage from './LegalPage';
import content from '../legal/avisoLegalContent';

export default function AvisoLegal() {
  return <LegalPage content={content} />;
}
